/* MDP · Correctifs du panier latéral (14/10/2026), SANS modifier assets/cart-drawer.js (fichier natif restauré).
   Chargé depuis le bloc Code personnalisé du pied de page (sections/footer-group.json), conservé par l'Updater.
   1. « Commander » : l'état de chargement est posé sur le bouton, y compris après le re-rendu AJAX du tiroir
      (le natif n'écoute que le bouton présent au chargement de la page ; écoute par délégation sur le document).
      21/10/2026 : pas d'état de chargement si le formulaire est invalide (ex. quantité > stock restée dans le
      champ) : le navigateur bloque l'envoi et le bouton restait figé (pointer-events: none).
      30/10/2026 : idem quand c'est le natif qui a posé l'état (tiroir pas encore re-rendu, Entrée dans un champ).
   2. Retour arrière depuis le checkout (cache navigateur) : le bouton n'est plus bloqué en chargement
      (tiroir et page panier).
   3. Erreur de quantité : le script natif plante (variable « message » non définie) et n'affiche rien ;
      on affiche le vrai message d'erreur. À RETIRER si FullStack corrige ce bug (sinon double message).
      21/10/2026 : idem pour /cart/add en erreur (produit épuisé, stock insuffisant : 422) : product-form.js,
      quick-add.js et cross-sell.js n'affichent rien dans ce cas. Message échappé (le toast natif l'insère en innerHTML).
   4. /cart/add en erreur (21/10/2026) : product-form.js, quick-add.js (et cross-sell.js, ajouté le 30/10/2026)
      diffusent quand même cart:updated (compteur +N alors que rien n'a été ajouté, tiroir ouvert qui plante sur
      « sections » absent). Ce faux cart:updated (sans sections, juste après un refus) est arrêté : le panier n'a
      pas changé. À RETIRER si FullStack teste response.ok. */
(function () {
  'use strict';
  if (window.__mdpCartFixes) return;
  window.__mdpCartFixes = true;

  var CHECKOUT = '[data-ref="checkout-button"]';
  // Sources natives qui diffusent cart:updated sans tester response.ok.
  var FAKE_SOURCES = ['product-form', 'quick-add', 'cross-sell'];

  // 1. Le natif (s'il écoute encore ce bouton) a déjà agi : on fixe l'état final ici.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('cart-drawer ' + CHECKOUT) : null;
    if (!btn || btn.disabled) return;
    btn.querySelectorAll('.is-loading').forEach(function (x) { x.classList.remove('is-loading'); });
    var form = btn.form;
    var invalid = !!form && typeof form.checkValidity === 'function' && !form.checkValidity();
    btn.classList.toggle('is-loading', !invalid);
  });

  // 2.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll(CHECKOUT + ', ' + CHECKOUT + ' .is-loading').forEach(function (x) { x.classList.remove('is-loading'); });
  });

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function errorText(d) {
    var e = d.errors;
    if (d.description && typeof d.description === 'string') return d.description;
    if (typeof e === 'string') return e;
    if (Array.isArray(e)) return e.join(', ');
    if (e && typeof e === 'object') {
      return Object.keys(e).map(function (k) { return [].concat(e[k]).join(', '); }).join(', ');
    }
    return d.message || '';
  }

  // 4. Instant du dernier /cart/add refusé : posé avant que product-form / quick-add / cross-sell lisent la réponse
  //    (notre .then est enregistré le premier), donc avant leur cart:updated. Écoute en capture sur window :
  //    passe avant tous les écouteurs du document (tiroir, compteur, Gift Box).
  //    Un vrai ajout renvoie toujours « sections » : seul l'événement sans sections est arrêté. L'instant n'est plus
  //    remis à zéro par le premier événement venu (deux ajouts simultanés, l'un refusé : le faux passait).
  var failedAddAt = 0;
  window.addEventListener('cart:updated', function (e) {
    var d = e.detail && e.detail.data;
    if (!d || d.sections || FAKE_SOURCES.indexOf(d.source) === -1) return;
    if (Date.now() - failedAddAt < 10000) e.stopImmediatePropagation();
  }, true);

  // 3. et 4.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;
  var CART_URL = /\/cart\/(add|change)(\.js)?(\?|$)/;
  window.fetch = function (input) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var m = CART_URL.exec(url);
      if (m) {
        var isAdd = m[1] === 'add';
        p.then(function (res) {
          if (!res || !res.clone) return;
          // /cart/add réussi : rien à lire (évite de parser une 2e fois une grosse réponse avec sections)
          if (isAdd && res.ok) return;
          if (isAdd) failedAddAt = Date.now();
          res.clone().json().then(function (d) {
            if (!d || (res.ok && !d.errors)) return;
            var message = errorText(d);
            if (!message) return;
            document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: esc(message) } }));
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (err) {}
    return p;
  };
})();
